import axios from 'axios';

export const contact = {
    getContactInvestor(data) {
        return axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API}/send_email/contact-investor`,
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },
    getReceiveEemailsInvestor(data) {
        return axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API}/send_email/receive-emails`,
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },
    getCancelEemailsInvestor(data) {
        return axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API}/send_email/cancel-emails`,
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },
};